export const getAttributeModelOptions = i18n => [{ key: 'Default', text: i18n.getString(_TL_('Last Click')) },
  { key: 'LastTouch', text: i18n.getString(_TL_('Last Touch')) }];

export const getRevenueOptions = i18n => [
  {
    key: 'FixedValue',
    text: i18n.getString(_TL_('Each conversion action has the same value')),
    ariaLabel: i18n.getString(_TL_('Each conversion action has the same value')),
  },
  {
    key: 'VariantValue',
    text: i18n.getString(_TL_('Conversion action value may vary (for example, by price)')),
    ariaLabel: i18n.getString(_TL_('Conversion action value may vary (for example, by price)')),
  },
  {
    key: 'NoValue',
    text: i18n.getString(_TL_('Don\'t assign a value')),
    ariaLabel: i18n.getString(_TL_('Don\'t assign a value')),
  },
];
